import {Component} from '@angular/core'

import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
    selector: 'information-modal',
    templateUrl: './information-modal.component.html',
    styleUrls: ['./information-modal.component.scss']
  })
export class InformationModal {
    constructor(
        private activeModal: NgbActiveModal
    ) {}

    bodyModal = null
    titleModal = null

    closeConfirmModal() {
        this.activeModal.close({
            confirmation: false
        })
    }
}
